// ============================================
// voiceCallSounds.js - FIXED
// No double play, separate context per sound
// ============================================

class VoiceCallSounds {
  constructor() {
    this.audioContext = null;
    this.currentSource = null;
  }

  // ✅ Stop any currently playing sound
  stopCurrentSound() {
    try {
      if (this.currentSource) {
        console.log('🛑 Stopping current sound...');
        this.currentSource.stop();
        this.currentSource.disconnect();
        this.currentSource = null;
      }
    } catch (error) {
      console.warn('⚠️ Error stopping sound:', error.message);
    }
  }

  // ✅ Play sound before AI starts speaking (call start)
  async playStartSound() {
    try {
      console.log('🔊 Playing call start sound...');
      
      // ✅ Stop any previous sound
      this.stopCurrentSound();
      
      const response = await fetch('/sound/start.mp3');
      if (!response.ok) {
        console.warn('⚠️ Start sound file not found - skipping');
        return;
      }

      const arrayBuffer = await response.arrayBuffer();
      
      // ✅ Create fresh audio context if needed
      if (!this.audioContext) {
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
        console.log('✅ Audio context created');
      }

      // ✅ Resume context if suspended
      if (this.audioContext.state === 'suspended') {
        await this.audioContext.resume();
        console.log('✅ Audio context resumed');
      }

      const audioBuffer = await this.audioContext.decodeAudioData(arrayBuffer);
      const source = this.audioContext.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(this.audioContext.destination);
      
      // ✅ Store source reference
      this.currentSource = source;
      
      // ✅ Handle when sound ends
      source.onended = () => {
        console.log('✅ Start sound finished');
        this.currentSource = null;
      };
      
      source.start(0);
      console.log('✅ Start sound playing');
      
    } catch (error) {
      console.warn('⚠️ Could not play start sound:', error.message);
      this.currentSource = null;
    }
  }

  // ✅ Play sound when ending call
  async playEndSound() {
    try {
      console.log('🔊 Playing call end sound...');
      
      // ✅ Stop any previous sound FIRST
      this.stopCurrentSound();
      
      const response = await fetch('/sound/intro.mp3');
      if (!response.ok) {
        console.warn('⚠️ End sound file not found - skipping');
        return;
      }

      const arrayBuffer = await response.arrayBuffer();
      
      // ✅ Create fresh audio context if needed
      if (!this.audioContext) {
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
        console.log('✅ Audio context created');
      }

      // ✅ Resume context if suspended
      if (this.audioContext.state === 'suspended') {
        await this.audioContext.resume();
        console.log('✅ Audio context resumed');
      }

      const audioBuffer = await this.audioContext.decodeAudioData(arrayBuffer);
      const source = this.audioContext.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(this.audioContext.destination);
      
      // ✅ Store source reference
      this.currentSource = source;
      
      // ✅ Handle when sound ends
      source.onended = () => {
        console.log('✅ End sound finished');
        this.currentSource = null;
      };
      
      source.start(0);
      console.log('✅ End sound playing');
      
    } catch (error) {
      console.warn('⚠️ Could not play end sound:', error.message);
      this.currentSource = null;
    }
  }

  // ✅ Cleanup - call when done
  cleanup() {
    console.log('🧹 Cleaning up audio...');
    
    try {
      this.stopCurrentSound();
      
      if (this.audioContext && this.audioContext.state !== 'closed') {
        this.audioContext.close();
        console.log('✅ Audio context closed');
      }
      
      this.audioContext = null;
      this.currentSource = null;
      
    } catch (error) {
      console.warn('⚠️ Cleanup error:', error.message);
    }
  }
}

export default VoiceCallSounds;